export const postRequest = url =>
    new Promise((resolve, reject) => {
        const xhr = new XMLHttpRequest();
        xhr.addEventListener('load', () => {
            if (xhr.readyState === 4 && xhr.status === 200) {
                resolve(JSON.parse(xhr.response));
            }
            if (xhr.readyState === 4) {
                reject(
                    xhr.response || {
                        message: `Status: ${xhr.status}, url: ${url}`,
                    },
                );
            }
        });
        xhr.open('POST', url, true);
        xhr.setRequestHeader('Accept', 'application/json, text/plain');
        xhr.send();
    });